export interface BookingResponse {
  Booking: Booking;
  Status: CreateBookingStatus;
  Errors: string[];
  PaymentAmount: number | null;
  StripePublishableKey: string;
  FormattedPaymentAmount: string;
  StripeAccountId: string;
  SetupIntentClientSecret: string;
  PaymentIntentSecret: string;
}

export interface Booking {
  Reference: string;
  RestaurantName: string;
  VisitDate: string;
  VisitTime: string;
  PartySize: number;
  ChannelCode: string;
  SpecialRequests: string;
  PromotionId: number | null;
  IpAddress: string;
  IsLeaveTimeConfirmed: boolean;
  Customer: Customer;
  ConciergeId: number | null;
  ConciergeEmail: string;
  ConciergeCustomerId: number | null;
  Token: string;
  PaymentInformation: PaymentInformation;
  AreaId: number | null;
  PaymentMethodId: string;
  PaymentIntentId: string;
  RoomNumber: string;
  PreorderGuestFormUrl: string;
  DeliveryAddress: DeliveryAddress;
  Households: number | null;
  IsWidgetBooking: boolean;
}

export interface Customer {
  Title: string;
  FirstName: string;
  Surname: string;
  MobileCountryCode: number | null;
  Mobile: string;
  Email: string;
  ReceiveEmailMarketing: boolean;
  ReceiveSmsMarketing: boolean;
  ReceiveResDiaryEmailMarketing: boolean;
  ReceiveResDiarySmsMarketing: boolean;
  MembershipId: string;
  CustomField: string;
  IsFavourite: boolean;
  Company: string;
  Phone: string;
  PhoneCountryCode: number | null;
  FullName: string;
  Postcode: string;
  Birthday: string | null;
  GroupEmailMarketingOptInText: string;
  GroupSmsMarketingOptInText: string;
  ResDiaryEmailMarketingOptInText: string;
  ResDiarySmsMarketingOptInText: string;
  ReceiveRestaurantEmailMarketing: boolean;
  ReceiveRestaurantSmsMarketing: boolean;
  RestaurantEmailMarketingOptInText: string;
  RestaurantSmsMarketingOptInText: string;
}

export interface PaymentInformation {
  IsCreditCardRequired: boolean;
  IsPaymentRequired: boolean;
  FormattedOutstandingAmount: string;
  StripeOutstandingTotal: number;
  StripePublishableKey: string;
  HasPageExpired: boolean;
  HoursToExpiry: string;
  MinutesToExpiry: string;
}

export interface DeliveryAddress {
  AddressLine1: string;
  AddressLine2: string;
  City: string;
  Postcode: string;
}

export enum CreateBookingStatus {
  Success = "Success",
  CustomerBlocked = "CustomerBlocked",
  NoAvailability = "NoAvailability",
  InvalidPromotion = "InvalidPromotion",
  InvalidBooking = "InvalidBooking",
  PaymentRequired = "PaymentRequired",
  CreditCardRequired = "CreditCardRequired",
  LeaveTimeConfirmationRequired = "LeaveTimeConfirmationRequired",
  PaymentFailed = "PaymentFailed",
  StripeAuthenticationRequired = "StripeAuthenticationRequired",
  Failure = "Failure",
  StripeError = "StripeError",
  AvailabilitySearchError = "AvailabiltySearchError",
  OutsideEnquiryPartySizeLimits = "OutsideEnquiryPartySizeLimits",
}
